
<div class="admin-dashboard-container">
    <app-accounts></app-accounts>
</div>
